export default "__VITE_ASSET__BaEaM6yf__"